export default __webpack_public_path__ + "static/media/chooserStudent.67848066.png";